/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NormalErrorGoodsProcessVo
 */
export interface NormalErrorGoodsProcessVo {
    /**
     * 商品检查单ID 有就填 没有就空着
     * @type {number}
     * @memberof NormalErrorGoodsProcessVo
     */
    checkOrderId?: number;
    /**
     * 处理方式 1 废弃, 2 退货, 3 无视错误, 4 仅退款, 5 重新检查， 6 补发
     * @type {number}
     * @memberof NormalErrorGoodsProcessVo
     */
    processMethod?: number;
    /**
     * 处理数量 管理端填此值，客户端不填
     * @type {number}
     * @memberof NormalErrorGoodsProcessVo
     */
    quantity?: number;
    /**
     * 退货收件人姓名  申请退货用
     * @type {string}
     * @memberof NormalErrorGoodsProcessVo
     */
    receiverName?: string;
    /**
     * 退货收件人地址  申请退货用
     * @type {string}
     * @memberof NormalErrorGoodsProcessVo
     */
    receiverAddress?: string;
    /**
     * 退货收件人电话  申请退货用
     * @type {string}
     * @memberof NormalErrorGoodsProcessVo
     */
    receiverMobileNo?: string;
    /**
     * 退货收件人邮编  申请退货用
     * @type {string}
     * @memberof NormalErrorGoodsProcessVo
     */
    receiverZip?: string;
    /**
     * 退货收件人详细地址  申请退货用
     * @type {string}
     * @memberof NormalErrorGoodsProcessVo
     */
    receiverAddressDetail?: string;
    /**
     * 退货订单 取货方式1 仓库快递 2 卖家回收
     * @type {number}
     * @memberof NormalErrorGoodsProcessVo
     */
    returnFetchGoodsMethod?: number;
    /**
     * 退货订单取货码
     * @type {string}
     * @memberof NormalErrorGoodsProcessVo
     */
    returnFetchGoodsCode?: string;
    /**
     * 退货订单取货时间
     * @type {string}
     * @memberof NormalErrorGoodsProcessVo
     */
    returnFetchGoodsDate?: string;
    /**
     * 订单ID
     * @type {number}
     * @memberof NormalErrorGoodsProcessVo
     */
    orderId?: number;
}

/**
 * Check if a given object implements the NormalErrorGoodsProcessVo interface.
 */
export function instanceOfNormalErrorGoodsProcessVo(value: object): value is NormalErrorGoodsProcessVo {
    return true;
}

export function NormalErrorGoodsProcessVoFromJSON(json: any): NormalErrorGoodsProcessVo {
    return NormalErrorGoodsProcessVoFromJSONTyped(json, false);
}

export function NormalErrorGoodsProcessVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NormalErrorGoodsProcessVo {
    if (json == null) {
        return json;
    }
    return {
        
        'checkOrderId': json['checkOrderId'] == null ? undefined : json['checkOrderId'],
        'processMethod': json['processMethod'] == null ? undefined : json['processMethod'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'receiverAddress': json['receiverAddress'] == null ? undefined : json['receiverAddress'],
        'receiverMobileNo': json['receiverMobileNo'] == null ? undefined : json['receiverMobileNo'],
        'receiverZip': json['receiverZip'] == null ? undefined : json['receiverZip'],
        'receiverAddressDetail': json['receiverAddressDetail'] == null ? undefined : json['receiverAddressDetail'],
        'returnFetchGoodsMethod': json['returnFetchGoodsMethod'] == null ? undefined : json['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': json['returnFetchGoodsCode'] == null ? undefined : json['returnFetchGoodsCode'],
        'returnFetchGoodsDate': json['returnFetchGoodsDate'] == null ? undefined : json['returnFetchGoodsDate'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
    };
}

export function NormalErrorGoodsProcessVoToJSON(json: any): NormalErrorGoodsProcessVo {
    return NormalErrorGoodsProcessVoToJSONTyped(json, false);
}

export function NormalErrorGoodsProcessVoToJSONTyped(value?: NormalErrorGoodsProcessVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkOrderId': value['checkOrderId'],
        'processMethod': value['processMethod'],
        'quantity': value['quantity'],
        'receiverName': value['receiverName'],
        'receiverAddress': value['receiverAddress'],
        'receiverMobileNo': value['receiverMobileNo'],
        'receiverZip': value['receiverZip'],
        'receiverAddressDetail': value['receiverAddressDetail'],
        'returnFetchGoodsMethod': value['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': value['returnFetchGoodsCode'],
        'returnFetchGoodsDate': value['returnFetchGoodsDate'],
        'orderId': value['orderId'],
    };
}

